import { css } from 'lit';

export const style = css`
  #personal-edit-form {
    padding-block: var(--refi-checkout-card-padding-block, '0.75rem');
    padding-inline: var(--refi-checkout-card-padding-inline, '1rem');
  }

  [hidden],
  .hidden {
    display: none;
  }

  @media (width >= 744px) {
    .button-container {
      text-align: right;
    }

    .update-button {
      float: right;
      margin-left: 1rem;
    }

    fs-button {
      display: inline-block;
    }

    .mobile-order {
      display: none;
    }
  }

  @media (width <= 743px) {
    fs-button {
      display: block;
    }

    .update-button {
      margin-bottom: 1rem;
    }

    .button-container {
      display: flex;
      flex-direction: column-reverse;
    }

    .desktop-order {
      display: none;
    }
  }
`;
